import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";

import WidgetContainer from "components/WidgetContainer/WidgetContainer";
import Button from "components/Button/Button";
import phonepeStats from "helpers/constants/phonepeStats";
import SwitchMerchantLogos from "images/bs-switch-merchant-users-logos.png";

import "./SwitchOverviewWidget.css";
const SwitchOverviewWidget = () => {
    const data = useStaticQuery(graphql`
        query BsSwitchOverviewQuery {
            mobileImage: file(
                relativePath: { eq: "bs-switch-sec-mobile-1x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(
                relativePath: { eq: "bs-switch-sec-web-1x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    return (
        <WidgetContainer stylesClass="switch">
            <div id="switch-section"></div>
            <div className="switch-overview">
                <div className="switch-overview__content">
                    <h1>
                        Get new users with <br /> PhonePe Switch
                    </h1>
                    <p className="switch-overview__content__text">
                        Switch gives you access to over{" "}
                        {phonepeStats.registeredUsers} million PhonePe users and
                        you only pay for realised business. Setting up an app on
                        PhonePe is cost-effective and requires minimal tech
                        investment.
                    </p>
                    <div className="switch-overview__content__btn-container">
                        <Button
                            btnText="Be on PhonePe Switch"
                            pagePath="/business-solutions/switch/"
                            btnStyle="btnStyle"
                        />
                    </div>
                </div>
                <div className="switch-overview__banner">
                    <div className="switch-overview__banner_img">
                        <Img
                            fluid={sources}
                            alt="PhonePe Switch"
                            imgStyle={{ objectFit: "contain" }}
                        />
                    </div>
                    <div className="switch-overview__banner__merchant_logo">
                        <p>Popular Merchants</p>
                        <img
                            src={SwitchMerchantLogos}
                            alt="list of merchant logo of phonepe"
                        />
                    </div>

                    <div className="switch-overview__banner__btn-container">
                        <Button
                            btnText="Be on PhonePe Switch"
                            pagePath="/business-solutions/switch/"
                            btnStyle="btnStyle"
                        />
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default SwitchOverviewWidget;
